"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCetEnvironmentInfo = exports.cetEnvironments = exports.cetDomains = void 0;
var cetEnvironments;
exports.cetEnvironments = cetEnvironments;
(function (cetEnvironments) {
  cetEnvironments["Production"] = "Production";
  cetEnvironments["Testing"] = "Testing";
  cetEnvironments["Development"] = "Development";
})(cetEnvironments || (exports.cetEnvironments = cetEnvironments = {}));
var cetDomains;
exports.cetDomains = cetDomains;
(function (cetDomains) {
  cetDomains["Production"] = "cet.ac.il";
  cetDomains["Testing"] = "testing.cet.ac.il";
  cetDomains["Development"] = "dev.cet.ac.il";
})(cetDomains || (exports.cetDomains = cetDomains = {}));
var getCetEnvironmentInfo = function getCetEnvironmentInfo() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var host = url || window.location.hostname.toLowerCase();
  var cetEnvironment = '';
  var cetDomain = '';
  var isDevelopment = false;
  var isTesting = false;
  var isProduction = false;
  if (host.includes('.dev')) {
    cetEnvironment = cetEnvironments.Development;
    cetDomain = cetDomains.Development;
    isDevelopment = true;
  } else if (host.includes('.testing')) {
    cetEnvironment = cetEnvironments.Testing;
    cetDomain = cetDomains.Testing;
    isTesting = true;
  } else {
    cetEnvironment = cetEnvironments.Production;
    cetDomain = cetDomains.Production;
    isProduction = true;
  }
  return {
    cetEnvironment: cetEnvironment,
    cetDomain: cetDomain,
    isDevelopment: isDevelopment,
    isTesting: isTesting,
    isProduction: isProduction
  };
};
exports.getCetEnvironmentInfo = getCetEnvironmentInfo;